// import font from '../styles/fonts/SantanderHeadline-Regular.woff2'
import font1 from '../styles/fonts/SantanderHeadline/SantanderHeadline-Regular.ttf'
import font2 from '../styles/fonts/SantanderMicroText/SantanderMicroText.ttf'
import font3 from '../styles/fonts/SantanderHeadline/SantanderHeadline-Bold.ttf'
import opentype from 'opentype.js'
import detector from '../utils/textUtils'
import { select as d3_select } from 'd3-selection'
let promises = null

String.prototype.parseTransform = function () {
  var prop = ['translate', 'matrix', 'rotate', 'skewX', 'skewY', 'scale']
  var val = this.match(/(translate|matrix|rotate|skewX|skewY|scale)\(.*?\)/g)
  var obj = {}
  if (val) {
    for (var i = 0, length = val.length; i < length; i++) {
      var item = val[i]
      var index = item.indexOf('(')
      var v = item.substring(index + 1, item.length - 1).split(/\,|\s/)
      var n = item.substring(0, index)
      obj[n] = {}
      switch (n) {
        case 'translate':
        case 'scale':
          obj[n].x = +v[0] || 0
          obj[n].y = +v[1] || 0
          break
        case 'rotate':
          obj[n].a = +v[0] || 0
          obj[n].x = +v[1] || 0
          obj[n].y = +v[2] || 0
          break
        case 'skewX':
        case 'skewY':
          obj[n].a = +v[0]
          break
        case 'matrix':
          obj[n].a = +v[0] || 0
          obj[n].b = +v[1] || 0
          obj[n].c = +v[2] || 0
          obj[n].d = +v[3] || 0
          obj[n].e = +v[4] || 0
          obj[n].f = +v[5] || 0
          break
      }
    }
  }

  obj.toString = function () {
    var builder = []
    for (var i = 0, length = prop.length; i < length; i++) {
      var n = prop[i]
      var o = this[n]
      if (!o) continue
      switch (n) {
        case 'translate':
        case 'scale':
          builder.push(n + '(' + o.x + ',' + o.y + ')')
          break
        case 'rotate':
          builder.push(n + '(' + o.a + ' ' + o.x + ' ' + o.y + ')')
          break
        case 'skewX':
        case 'skewY':
          builder.push(n + '(' + o.a + ')')
          break
        case 'matrix':
          builder.push(
            n + '(' + o.a + ',' + o.b + ',' + o.c + ',' + o.d + ',' + o.e + ',' + o.f + ')'
          )
          break
      }
    }
    return builder.join(' ')
  }

  return obj
}

function em2px(str, fontSize) {
  if (!str || str === '') return 0
  else if (str.indexOf('em') >= 0) return +str.replace('em', '') * fontSize
  else return +str
}
export const FONTS = [
  { url: font1, id: 'santanderFont1', fontFamily: 'santander-headline-embedded' },
  { url: font2, id: 'santanderFont2', fontFamily: 'santander-microtext-embedded' },
  { url: font3, id: 'santanderFont3', fontFamily: 'santander-headline-bold-embedded' },
]

export function fontCheck() {
  if (window.santanderFont1Base64) return new Promise(resolve => resolve())
  else return loadFonts(FONTS)
}

function loadFonts(fonts) {
  if (!promises) {
    promises = []
    fonts.forEach(f => {
      promises.push(loadFont(f))
    })
  }
  return Promise.all(promises)
}

export function svgfontCheck() {
  if (FONTS[0].svgFont) return new Promise(resolve => resolve())
  else return loadSvgFonts(FONTS)
}
function loadSvgFonts(fonts) {
  let svgpromises = []
  fonts.forEach(f => {
    return svgpromises.push(loadSVGFont(f))
  })
  return Promise.all(svgpromises)
}

function loadSVGFont(fontDef) {
  // opentype.load(fontDef.url, function(err, font) {
  //   if (err) {
  //       alert('Font could not be loaded: ' + err);
  //   } else {
  //       // Construct a Path object containing the letter shapes of the given text.
  //       // The other parameters are x, y and fontSize.
  //       // Note that y is the position of the baseline.
  //       // const path = font.getPath('Hello, World!', 0, 150, 72);
  //       // console.log("FONT PATH",path)
  //       fontDef.svgFont = font

  //   }
  return new Promise((res, rej) => {
    opentype.load(fontDef.url, function (err, font) {
      fontDef.svgFont = font
      window.santanderFontSvg = true
      if (err) rej(err)
      else res(font)
    })
  })
}
export function loadFont(fontDef) {
  console.log('Loading font...', fontDef.id)
  return getBinary(fontDef).then(response => {
    window[`santander${fontDef.id}Base64`] = base64Encode(response)
    let styleElement = generateFontStyleElement(fontDef, 'html')
    document.head.appendChild(styleElement)
    return new Promise(resolve => {
      let testDiv = document.createElement('div')
      testDiv.style.fontFamily = fontDef.fontFamily
      testDiv.style.visibility = 'hidden'
      testDiv.innerHTML = 'abcdefghijklmnopqrstuvwxyz'
      document.body.appendChild(testDiv)
      let checkAndLoop = () => {
        if (!document.fonts.check('1em ' + fontDef.fontFamily)) {
          requestAnimationFrame(checkAndLoop)
        } else {
          testDiv.remove()
          // console.log("Font ready!")
          resolve()
        }
      }
      checkAndLoop()
    })
  })
}

function getBinary(fontDef) {
  // var xhr = new XMLHttpRequest();
  // xhr.open("GET", font, false);
  // // xhr.open("GET", font, true);
  // xhr.overrideMimeType("text/plain; charset=x-user-defined");
  // xhr.send(null);
  // return xhr.responseText;
  return new Promise((resolve, reject) => {
    var xhr = new XMLHttpRequest()
    xhr.open('GET', fontDef.url, true)
    xhr.overrideMimeType('text/plain; charset=x-user-defined')
    xhr.onreadystatechange = function () {
      // In local files, status is 0 upon success in Mozilla Firefox
      if (xhr.readyState === XMLHttpRequest.DONE) {
        var status = xhr.status
        if (status === 0 || (status >= 200 && status < 400)) {
          resolve(xhr.responseText)
        } else {
          reject(status)
        }
      }
    }
    xhr.send()
    // return xhr.responseText;
    // loadScript(src, (err, script) => {
    //   if (err) reject(err)
    //   else resolve(script);
    // });
  })
}

// Base64 encode binary string
// Stolen from http://stackoverflow.com/questions/7370943/retrieving-binary-file-content-using-javascript-base64-encode-it-and-reverse-de
function base64Encode(str) {
  var CHARS = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/'
  var out = '',
    i = 0,
    len = str.length,
    c1,
    c2,
    c3
  while (i < len) {
    c1 = str.charCodeAt(i++) & 0xff
    if (i == len) {
      out += CHARS.charAt(c1 >> 2)
      out += CHARS.charAt((c1 & 0x3) << 4)
      out += '=='
      break
    }
    c2 = str.charCodeAt(i++)
    if (i == len) {
      out += CHARS.charAt(c1 >> 2)
      out += CHARS.charAt(((c1 & 0x3) << 4) | ((c2 & 0xf0) >> 4))
      out += CHARS.charAt((c2 & 0xf) << 2)
      out += '='
      break
    }
    c3 = str.charCodeAt(i++)
    out += CHARS.charAt(c1 >> 2)
    out += CHARS.charAt(((c1 & 0x3) << 4) | ((c2 & 0xf0) >> 4))
    out += CHARS.charAt(((c2 & 0xf) << 2) | ((c3 & 0xc0) >> 6))
    out += CHARS.charAt(c3 & 0x3f)
  }
  return out
}

export function generateFontStyleElement(fontDef, type) {
  var base64EncodedFont = window[`santander${fontDef.id}Base64`]
  var fontCode =
    `@font-face { font-family: '${fontDef.fontFamily}'; src: url('data:application/font-woff;base64,` +
    base64EncodedFont +
    "') format('woff'); font-style: normal; font-weight: normal }"
  let styleElement
  if (type === 'svg') {
    styleElement = document.createElementNS('http://www.w3.org/2000/svg', 'style')
    styleElement.type = 'text/css'
    styleElement.innerHTML = fontCode
  } else {
    styleElement = document.createElement('style')
    styleElement.type = 'text/css'
    if (styleElement.styleSheet) {
      styleElement.styleSheet.cssText = fontCode
    } else {
      styleElement.innerHTML = fontCode
    }
  }
  // document.head.appendChild(styleElement);
  return styleElement
}

export function getPath(str, fontFamily, fontSize) {
  let svgFont = FONTS.find(f => f.fontFamily === fontFamily).svgFont
  return svgFont.getPath(str, 0, 0, fontSize, { kerning: false }).toPathData()
}

export function divToSVGText(source, target) {
  let textContent = source.node().textContent
  if (textContent !== '') {
    let lines = detector.getLines(source.node())
    let wordCount = 0
    lines.forEach((l, i) => {
      let lineContent = textContent
        .split(' ')
        .slice(wordCount, wordCount + l.length)
        .join(' ')

      let fontSize = +window.getComputedStyle(source.node()).fontSize.replace('px', '')
      let fontWeight = window.getComputedStyle(source.node()).fontWeight
      let fontFamily = source.node().style.fontFamily
      if (fontFamily === '' || !fontFamily) fontFamily = 'santander-microtext-embedded'
      if (fontWeight === 'bold' || fontWeight > 600) {
        fontFamily = 'santander-headline-bold-embedded'
        // fontSize += 1//BASUA DE FUENTE QUE TENENE...
      }
      let pathData = getPath(lineContent, fontFamily, fontSize)
      let x = 0
      let y = 17 + i * fontSize //BASTANTE BASURIL 17 margin del "padre"??? y el i*fonstize tp esta muy bien...
      target
        .append('path')
        .attr('d', pathData)
        .attr('transform', `translate(${x},${y})`)
        .attr('fill', source.node().style.color || 'currentColor')
      wordCount += l.length
    })
  }
}
function t2path(source) {
  let str = source.text()
  // let fontSize = source.attr('font-size') ? (+source.attr('font-size').replace('px','')) : 14
  let fontSize = +window.getComputedStyle(source.node()).fontSize.replace('px', '')
  let fontFamily = window.getComputedStyle(source.node()).fontFamily
  let fontWeight = window.getComputedStyle(source.node()).fontWeight

  if (fontFamily === '' || !fontFamily) fontFamily = 'santander-microtext-embedded'
  if (fontWeight === 'bold' || fontWeight > 600) {
    fontFamily = 'santander-headline-bold-embedded'
    // fontSize += 1 //BASUA DE FUENTE QUE TENENE...
  }
  let pathData = getPath(str, fontFamily, fontSize)

  let self_transform = source.attr('transform')
  if (self_transform) self_transform = self_transform.parseTransform()
  else self_transform = 'translate(0,0) rotate(0)'.parseTransform()

  let offset_transform = getOffsets(source)
  return { pathData, transform: self_transform.toString() + ' ' + offset_transform.toString() }
}
function getOffsets(source) {
  let computedTransform = 'translate(0,0) rotate(0)'.parseTransform()
  let parent = d3_select(source.node().parentNode)
  let bbox = source.node().getBBox()
  let parentBbox = source.node().parentNode.getBBox()
  let fontSize = +window.getComputedStyle(source.node()).fontSize.replace('px', '')
  let textWidth = source.node().getComputedTextLength()
  
  // DANGEROUS CHANGES (para los multi tspans de los piechart values)
  let fullWidth = source.node().tagName==='tspan'?+parentBbox.width:+textWidth
  if (
    source.attr('text-anchor') === 'end' ||
    (!source.attr('text-anchor') && parent.attr('text-anchor') === 'end')
  ){
    computedTransform.translate.x -= fullWidth
    if(source.node().tagName==='tspan') computedTransform.translate.x += bbox.x - parentBbox.x  //PARA MULTI SPANS
  }
  else if (
    source.attr('text-anchor') === 'middle' ||
    (!source.attr('text-anchor') && parent.attr('text-anchor') === 'middle')
  ) {
    computedTransform.translate.x -= textWidth / 2
  }
  //SOLO SIRVE PARA LOS "label: VALUE" del donut, por eso el "if tspan"... (en los otros (scatter) no aplica)
  else if(source.node().tagName==='tspan'){
    computedTransform.translate.x += bbox.x - parentBbox.x  //PARA MULTI SPANS
  }
  //BASURA MAXIMA.... Para los "label: value" del donut con wrapping....
  if(source.node().tagName==='tspan' && !source.attr('dy') && !source.attr('y')){
    computedTransform.translate.y += bbox.y - parentBbox.y  //PARA MULTI SPANS
  }

  if (source.attr('alignment-baseline') === 'middle') computedTransform.translate.y += em2px("0.2em", fontSize) //BULLSHIT
  if (source.attr('alignment-baseline') === 'central') computedTransform.translate.y += em2px("0.2em", fontSize) //BULLSHIT
  if (source.attr('dominant-baseline') === 'middle') computedTransform.translate.y += em2px("0.2em", fontSize) //BULLSHIT
  if (source.attr('dominant-baseline') === 'central') computedTransform.translate.y += em2px("0.2em", fontSize) //BULLSHIT

  if (source.attr('dx')) computedTransform.translate.x += em2px(source.attr('dx'), fontSize)
  if (source.attr('x')) computedTransform.translate.x += em2px(source.attr('x'), fontSize)

  if (source.attr('y')) computedTransform.translate.y += em2px(source.attr('y'), fontSize)
  //BASURA MAXIMA.... para la susie...!!!!
  if (source.attr('dy')) {
    if (source.attr('y')) computedTransform.translate.y += em2px(source.attr('dy'), fontSize)
    else computedTransform.translate.y += bbox.y - parentBbox.y + em2px('0.8em', fontSize)
  }
  return computedTransform
}
export function textToSVGText(source, target) {
  let arr = source.selectAll('tspan').nodes()
  let fontColor = source.attr('fill') || 'currentColor'
  if (arr.length > 0) {
    // BASURA MAXIMA....para la susie...!!!!
    // No se porque "tambien" para los ticks... ????!!!! pero no funcionaban con "axis-right"
    let parentTransform // = getOffsets(source) // source.attr('transform')
    if (source.node().closest('.annotation')) parentTransform = getOffsets(source)
    // me lo cargo porqeu SI que queremos el transform rotate!, y el caso que "petaba" se arregla con lo de la 327
    // else if (source.node().closest('.tick')) parentTransform = null
    else parentTransform = source.attr('transform')

    let parent = target.append('g').attr('transform', parentTransform)
    arr.forEach((ts, i) => {
      let { pathData, transform } = t2path(d3_select(ts))
      parent.append('path').attr('d', pathData).attr('transform', transform).attr('fill', fontColor)
    })
  } else {
    let { pathData, transform } = t2path(source)
    target.append('path').attr('d', pathData).attr('transform', transform).attr('fill', fontColor)
  }
}
